import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Sidebar from './Sidebar';
import '../styles/layout.css';

const Layout = ({ children, title, subtitle }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const userMenuRef = useRef(null);
  const { user, sucursal, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const getInitials = (name) => {
    if (!name) return 'U';
    return name.split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase();
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (userMenuRef.current && !userMenuRef.current.contains(e.target)) {
        setUserMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="layout">
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
      />

      <main className={`main-content ${collapsed ? 'sidebar-collapsed' : ''}`}>
        <div className="topbar">
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <button className="mobile-menu-btn" onClick={() => setMobileOpen(true)}>
              ☰
            </button>
            <div className="topbar-title">
              <h1>{title || 'Dashboard'}</h1>
              {subtitle && <p>{subtitle}</p>}
            </div>
          </div>

          <div className="topbar-context">
            <div className="topbar-context-item" title="Empresa">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 21h18M5 21V7l7-4 7 4v14M9 9h.01M9 13h.01M9 17h.01M15 9h.01M15 13h.01M15 17h.01"/>
              </svg>
              <div>
                <span className="topbar-context-label">Empresa</span>
                <span className="topbar-context-value">{user?.empresa || '—'}</span>
              </div>
            </div>
            <div className="topbar-context-separator" />
            <div className="topbar-context-item" title="Sede">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                <circle cx="12" cy="10" r="3"/>
              </svg>
              <div>
                <span className="topbar-context-label">Sede</span>
                <span className="topbar-context-value">{sucursal?.nombre || '—'}</span>
              </div>
            </div>
          </div>

          <div className="topbar-user" ref={userMenuRef}>
            <div className="topbar-user-info" onClick={() => setUserMenuOpen(!userMenuOpen)}>
              <div className="topbar-meta">
                <span className="topbar-username">{user?.nombre}</span>
                <span className="topbar-empresa">{user?.empresa}</span>
              </div>
              <div className="topbar-avatar">
                {getInitials(user?.nombre)}
              </div>
              <span className={`topbar-chevron ${userMenuOpen ? 'open' : ''}`}>▾</span>
            </div>

            {userMenuOpen && (
              <div className="topbar-dropdown">
                <div className="topbar-dropdown-header">
                  <div className="topbar-dropdown-avatar">{getInitials(user?.nombre)}</div>
                  <div>
                    <div className="topbar-dropdown-name">{user?.nombre}</div>
                    <div className="topbar-dropdown-email">{user?.usuario}</div>
                  </div>
                </div>
                <div className="topbar-dropdown-divider" />
                <div className="topbar-dropdown-item" onClick={() => { setUserMenuOpen(false); navigate('/utilitarios/usuarios'); }}>
                  <span>👤</span> Mi perfil
                </div>
                <div className="topbar-dropdown-divider" />
                <div className="topbar-dropdown-item topbar-dropdown-logout" onClick={handleLogout}>
                  <span>🚪</span> Cerrar Sesión
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="page-content">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;
